export enum Features {
  Unknown = "Unknown",
  ReadDataFromSASS = "ReadDataFromSASS",
  SignatureDetectionIntelligence = "SignatureDetectionIntelligence",
  AutomateDigitizationOfHanddrawnSignature = "AutomateDigitizationOfHanddrawnSignature",
  VirtualMeeting = "VirtualMeeting",
  RonClosingMonitor = "RonClosingMonitor",
  RcmPanelActions = "RcmPanelActions"
}
